export default __webpack_public_path__ + "static/media/webcam12.f4958802.jfif";